import { ReactElement } from 'react';
import { ErrorBoundary } from '../monitoring/error-boundary';
import { EventNarrativeContent, EventNarrativeProps } from './event-narrative-content';

export type { EventNarrativeProps };

export function EventNarrative(props: EventNarrativeProps): ReactElement {
    return (
        <ErrorBoundary name="EVENT_PANEL_ADDITIONAL_INFOS" messageVerbNoun="loading the narrative">
            <EventNarrativeContent {...props} />
        </ErrorBoundary>
    );
}
